import {enumType} from '../common/enumType';

export const AzureStorageType = enumType({
   FILE: 'File',
   APPEND_BLOB: 'Append Blob',
   BLOCK_BLOB: 'Block Blob',
   PAGE_BLOB: 'Page Blob',
});
